import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import PrivateRoute from "./containers/PrivateRoute";

import AuthView from "./views/Auth";
import RoomsView from "./views/Rooms";
import LogoutView from "./views/Logout";
import NewRoomView from "./views/NewRoom";
import RoomView from "./views/Room";
import RoomResultView from "./views/RoomResult";
import EditorView from "./views/Editor";

import "firebaseui/dist/firebaseui.css";
import "./App.css";

const EDITOR_ROUTE = "/rooms/:roomId/tiles/:tileId";
const ROOMS_ROUTE = "/rooms";
const NEW_ROOM_ROUTE = "/rooms/new";
const ROOM_ROUTE = "/rooms/:roomId";
const ROOM_RESULT_ROUTE = "/rooms/:roomId/result";
const SIGN_IN_ROUTE = "/signin";
const LOGOUT_ROUTE = "/logout";

export function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={SIGN_IN_ROUTE} component={AuthView} />
        <PrivateRoute exact path={ROOMS_ROUTE} component={RoomsView} />
        <PrivateRoute exact path={NEW_ROOM_ROUTE} component={NewRoomView} />
        <PrivateRoute exact path={ROOM_ROUTE} component={RoomView} />
        <PrivateRoute path={EDITOR_ROUTE} component={EditorView} />
        <PrivateRoute path={ROOM_RESULT_ROUTE} component={RoomResultView} />
        <Route exact path={LOGOUT_ROUTE} component={LogoutView} />
        <Redirect to={ROOMS_ROUTE} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
